export class PropTenantAttribute {
  Ptat_TenantAttributeID: number;
  Ptat_TenantID: string;
  Ptat_TenantAttributeCodeID: string;
  Ptat_Notes: string;
  /*
          public int Ptat_TenantAttributeID { get; set; }
        public string Ptat_TenantID { get; set; }
        public string Ptat_TenantAttributeCodeID { get; set; }
        public byte[] UpdatedOn { get; set; }
        public string Ptat_Notes { get; set; }

   */
}
